/**
 * Normalise whatever the adopt-device screen received into a bare pairing code.
 *
 * A FaceID terminal renders its QR as the admin-panel URL `{panel}/enroll/{code}`
 * (so a plain camera app opens the web panel too). The mobile scanner, however,
 * needs just the `{code}` to call `/admin/enrollments/{code}`. This accepts:
 *   - a full URL:      https://panel.sam-vision.uz/enroll/A7Y2MKJT[?x=1][#y]
 *   - a bare path:     /enroll/A7Y2MKJT
 *   - a plain code:    A7Y2MKJT   (manual entry — passes through unchanged)
 * and returns the pairing code verbatim (case preserved — the scanned URL carries
 * exactly what the server minted).
 */
export function parsePairingCode(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }
  // Prefer the segment right after `/enroll/`, ignoring any query/hash/trailing slash.
  const match = trimmed.match(/\/enroll\/([^/?#\s]+)/i);
  return (match ? match[1] : trimmed).trim();
}
